<template>
  <Navbar />
  <div
    class="login-prompt"
    :style="isLoggedIn ? 'display: none' : 'display:flex'"
  >
    <h1>We are sorry... To access this page you must be logged in!</h1>
    <p>Click here to log in.</p>
    <Button
      text="Log In"
      id="login-btn"
      @click="$router.push('/login?redirect=' + fullPath)"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Button from "@/components/Button";
import Swal from "sweetalert2";
import axios from "axios";

let headers = {};

function respond(invitationID, response, self) {
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-right",
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  headers["content-type"] = "application/json";

  if (
    response.toLowerCase() != "decline" &&
    response.toLowerCase() != "accept"
  ) {
    Toast.fire({
      icon: "error",
      title: "Sorry... There are no available users near you at the moment.",
    });
  }

  let text = response.toLowerCase() == "decline" ? "declined" : "accepted";

  axios
    .get(
      `${
        process.env.VUE_APP_BACKEND
      }/walk/${invitationID}/${response.toLowerCase()}`,
      { headers: headers }
    )
    .then(function () {
      // console.log(res);
      Toast.fire({
        icon: "success",
        title: "Success",
        text: "You have successfully " + text + " the invitation.",
      })
        .then(() => {
          self.$router.push("/notifications");
        })
        .catch(() => {
          self.$router.push("/notifications");
        });
    })
    .catch(function (err) {
      // console.log(err);
      Toast.fire({
        icon: "error",
        title: "There was an error.",
        text: `${err}`,
      })
        .then(() => {
          self.$router.push("/notifications");
        })
        .catch(() => {
          self.$router.push("/notifications");
        });
    });
}

export default {
  name: "InvitationResponse",
  components: {
    Navbar,
    Button,
  },
  data() {
    return {
      jwt: "",
      isLoggedIn: false,
      fullPath: "/invitation_response",
      invitationID: "",
      response: "",
    };
  },
  mounted() {
    let title = "Invitation Response - Dating4Pets";
    document.title = title;

    this.jwt = localStorage.getItem("jwt");
    if (this.jwt == null) {
      this.isLoggedIn = false;
    } else {
      this.isLoggedIn = true;
      //   // FOR TESTING
      //   this.isLoggedIn = false;
    }

    headers = {
      Authorization: "Bearer " + this.jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      // .then(function () {})
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });

    this.fullPath = this.$router.currentRoute.value.fullPath;

    const query = window.location.search;
    const getParameters = new URLSearchParams(query);
    this.invitationID = getParameters.get("id");
    this.response = getParameters.get("response");
    // console.log(this.invitationID, this.response);
    respond(this.invitationID, this.response, this);
  },
};
</script>

<style scoped>
.login-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90%;
  position: absolute;
  background: white;
  padding: 2em;
  /* padding-block-start: 2em; */
  margin: 1em;
  margin-block-start: 5em;
  border-radius: 1em;
  box-shadow: var(--light-box-shadow);
  gap: var(--gap);
}

#login-btn {
  justify-self: center;
}
</style>
